<template>
  <div id="questionnaireStatus" >
    <b>評価状況一覧画面</b><br/><br/>

    <table class="table icon">
      <tr>
        <td>評価状況一覧を参照いただきます。</td>
      </tr>
    </table><br/>

    <form onsubmit="return false;">
      
      <div  class="bootstrap-table fixed-table-container" style="margin-bottom:10px;margin-bottom:10px;width: 100%;">
        <table id="rptHeader2" class="table table-striped">
          <thead>
            <tr>
              <td><b>評価者</b></td>
              <td><b>被評価プロジェクト</b></td>
              <td><b>被評価者</b></td>
              <td><b>評価期間</b></td>
              <td><b>評価状況</b></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index4) in rows" v-bind:key="'row' + index4" >
              <td>{{row.appraiserMemberInfo.memberName}}</td>
              <td>{{row.projectInfo.projectName}}</td>
              <td>{{row.evaluateeMemberInfo.memberName}}</td>
              <td>
                <font v-for="(rowOptionYearMonth, index5) in row.optionYearMonths" v-bind:key="'rowOptionYearMonth' + index5">
                  {{ rowOptionYearMonth.text }}
                </font>
              </td>
              <td style="white-space: nowrap;">
                <div id="confirmLink" v-if="row.skipApplyStatus=='01'" >
                    評価スキップ申請<br/>
                    <a @click.prevent="skipApplyConfirm(row,true);" >承認</a>/
                    <a @click.prevent="skipApplyConfirm(row,false);">却下</a>
                </div>
                <div v-else>
                    未評価
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <button @click="$router.push({ name: 'mains', params: { } });" class="btn-mid" style="width:250px;">メイン画面へ</button><br/>
    </form>
  </div>
</template>

<script>
  export default {
    name: "questionnaireStatus",
    data() {
      return {
          // heads: [ ],
          rows:  [ { projectInfo: { projectID: '', projectName: '', startDate: '', endDate: '' },
                     evaluateeMemberInfo: { memberID: '', memberName: '' },
                     appraiserMemberInfo: { memberID: '', memberName: '' },
                     optionYearMonths: [ { value: '', text: '', selected: true }, ],
                    }
                 ],
      }
    },
    mounted() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = '/static/js/common.js?v=17';
      document.body.appendChild(s);
      this.init();
    },
    methods: {
      init: function () {
        var self = this;

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = self.$route.params;
          common.getAxios().post(process.env.API_URL +"/api/QuestionnaireStatusInit", data)
            .then(function (res) {
              if (res.data) {
                self.rows = res.data.rows;
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });

      },
      skipApplyConfirm: function (row,isApprove ) {
        var self = this;
        var data = { rowData:JSON.stringify(row) ,isApprove : isApprove?'1':'0' };
        $("#confirmLink").attr("disabled", true);
        common.getAxios().post(process.env.API_URL +"/api/QuestionnaireSkipConfirm", data)
          .then(function (res) {
            $("#confirmLink").attr("disabled", false);
            // 処理正常の場合

            alert("評価スキップ申請" +(isApprove?"承認":"却下") + "しました。")
            if (res.data == '') {
              if(!self.$route.params["directEvalFlg"]){
                // 次の評価実施へ
                self.init();
              }
              else{
                // 直接評価
                self.$router.back(-1);
              }
            }
            // 処理エラーの場合
            else {
              alert(res.data);
            }

          })
          .catch(function (err) {
            alert(err);
            $("#confirmLink").attr("disabled", false);
          });
        return false;
      },
    },

  };
</script>



// WEBPACK FOOTER //
// questionnaireStatus.vue?4b720a1d